module.exports = __webpack_public_path__ + "img/forecast-logo.f699005e.png";